import React from "react";
import { Clock, ChefHat } from "lucide-react";

interface WaitingScreenProps {
  pendingSalgada: number;
  pendingDoce: number;
  pendingSalaoSalgada: number;
  pendingSalaoDoce: number;
  isFilaSalgada: boolean;
  isFilaDoce: boolean;
  isFilaSalaoSalgada: boolean;
  isFilaSalaoDoce: boolean;
  isFilaRodizioSalgada: boolean;
  isFilaRodizioDoce: boolean;
}

const WaitingScreen: React.FC<WaitingScreenProps> = ({
  pendingSalgada,
  pendingDoce,
  pendingSalaoSalgada,
  pendingSalaoDoce,
  isFilaSalgada,
  isFilaDoce,
  isFilaSalaoSalgada,
  isFilaSalaoDoce,
  isFilaRodizioSalgada,
  isFilaRodizioDoce,
}) => {
  const cards: {
    key: string;
    title: string;
    count: number;
    border: string;
    bg: string;
    titleColor: string;
    iconColor: string;
    countColor: string;
    hintColor: string;
  }[] = [];

  if (isFilaSalgada) {
    cards.push({
      key: "salgada",
      title: "Fila Salgada",
      count: pendingSalgada,
      border: "border-orange-200",
      bg: "bg-orange-50",
      titleColor: "text-orange-500",
      iconColor: "text-orange-600",
      countColor: "text-orange-700",
      hintColor: "text-orange-500",
    });
  }
  if (isFilaDoce) {
    cards.push({
      key: "doce",
      title: "Fila Doce",
      count: pendingDoce,
      border: "border-pink-200",
      bg: "bg-pink-50",
      titleColor: "text-pink-500",
      iconColor: "text-pink-600",
      countColor: "text-pink-700",
      hintColor: "text-pink-500",
    });
  }
  if (isFilaSalaoSalgada) {
    cards.push({
      key: "salao_salgada",
      title: "Salão Salgada",
      count: pendingSalaoSalgada,
      border: "border-orange-200",
      bg: "bg-orange-50",
      titleColor: "text-orange-500",
      iconColor: "text-orange-600",
      countColor: "text-orange-700",
      hintColor: "text-orange-500",
    });
  }
  if (isFilaSalaoDoce) {
    cards.push({
      key: "salao_doce",
      title: "Salão Doce",
      count: pendingSalaoDoce,
      border: "border-pink-200",
      bg: "bg-pink-50",
      titleColor: "text-pink-500",
      iconColor: "text-pink-600",
      countColor: "text-pink-700",
      hintColor: "text-pink-500",
    });
  }
  if (isFilaRodizioSalgada) {
    cards.push({
      key: "rodizio_salgada",
      title: "Rodízio Salgada",
      count: 0,
      border: "border-amber-200",
      bg: "bg-amber-50",
      titleColor: "text-amber-600",
      iconColor: "text-amber-600",
      countColor: "text-amber-700",
      hintColor: "text-amber-600",
    });
  }
  if (isFilaRodizioDoce) {
    cards.push({
      key: "rodizio_doce",
      title: "Rodízio Doce",
      count: 0,
      border: "border-blue-200",
      bg: "bg-blue-50",
      titleColor: "text-blue-600",
      iconColor: "text-blue-600",
      countColor: "text-blue-700",
      hintColor: "text-blue-600",
    });
  }

  return (
    <div className="mt-12 text-center">
      <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-green-50">
        <ChefHat size={48} className="animate-pulse text-green-500" />
      </div>
      <h2 className="mb-2 text-2xl font-bold text-neutral-700">
        Aguardando pedido...
      </h2>
      <p className="mx-auto mb-6 max-w-md text-sm text-neutral-500">
        O próximo pedido compatível com a sua fila é atribuído automaticamente.
        Os números abaixo são só da{" "}
        <span className="font-medium text-neutral-600">fila de hoje</span> na
        loja (pendentes ou aguardando borda, ainda sem produção iniciada).
      </p>

      <div className="mx-auto flex max-w-2xl flex-wrap justify-center gap-4">
        {cards.map((card) => (
          <div
            key={card.key}
            className={`min-w-[140px] flex-1 rounded-xl border-2 ${card.border} ${card.bg} p-4`}
          >
            <div
              className={`mb-1 text-xs font-semibold uppercase tracking-wide ${card.titleColor}`}
            >
              {card.title}
            </div>
            <div className="flex items-center justify-center gap-1.5">
              <Clock size={16} className={card.iconColor} />
              <span className={`text-2xl font-bold ${card.countColor}`}>
                {card.count}
              </span>
            </div>
            <div className={`text-xs ${card.hintColor}`}>na fila hoje</div>
          </div>
        ))}
      </div>

      <div className="mt-8">
        <div className="mx-auto flex items-center justify-center gap-2 text-sm text-neutral-400">
          <div className="h-2 w-2 animate-bounce rounded-full bg-success delay-0" />
          <div className="h-2 w-2 animate-bounce rounded-full bg-success delay-150" />
          <div className="h-2 w-2 animate-bounce rounded-full bg-success delay-300" />
          <span className="ml-2">
            Sincronizando a fila o tempo todo (~1&nbsp;s) e ao vivo quando a
            integração mudar
          </span>
        </div>
      </div>
    </div>
  );
};

export default WaitingScreen;
